module.exports = __webpack_public_path__ + "img/1162b2e.png";